import { useApi } from '@shared/api'
import type {
  FunnelReport,
  FunnelType,
  FunnelsCatalog,
  FunnelQueryParams,
  UtmReport,
  UtmGroupBy,
} from '~/utils/types/funnels'

/** Пустые фильтры в query не шлём: бэкенд сам подставит период по умолчанию. */
const toQuery = (params: FunnelQueryParams): string => {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value) search.append(key, String(value))
  }
  const query = search.toString()
  return query ? `?${query}` : ''
}

export const apiAdminFunnels = {
  /** Справочник воронок и их шагов — админка не дублирует описание у себя. */
  async getCatalog(): Promise<FunnelsCatalog> {
    const { data } = await useApi(true, true).get<FunnelsCatalog>('/admin/analytics/funnels')
    return data
  },

  async getFunnel(type: FunnelType, params: FunnelQueryParams = {}): Promise<FunnelReport> {
    const { data } = await useApi(true, true).get<FunnelReport>(
      `/admin/analytics/funnels/${type}${toQuery(params)}`,
    )
    return data
  },
}

export const apiAdminUtm = {
  /** Заказы и выручка по рекламным кампаниям за период. */
  async getReport(
    params: { startDate?: string; endDate?: string; groupBy?: UtmGroupBy } = {},
  ): Promise<UtmReport> {
    const { data } = await useApi(true, true).get<UtmReport>(
      `/admin/analytics/utm${toQuery(params as FunnelQueryParams)}`,
    )
    return data
  },
}
